import { ExportFormHook } from '@app/modules/social-export/hooks/useSocialExportFactory';
import { socialExport } from '@mi-front/api-clients';
import { TikTokPublishForm } from './TikTokPublishForm';
import { TikTokSettingsForm } from './TikTokSettingsForm';

export const useTikTokExport: ExportFormHook<
  socialExport.TiktokPublishDto,
  socialExport.TiktokSettingsDto
> = () => {
  return {
    PublishForm: TikTokPublishForm,
    SettingsForm: TikTokSettingsForm,
  };
};
